import React, {useState} from 'react'
import UiKit from '../../../../common/uikit'
import {useTranslate} from '../../../../hooks/use'

const Helper = () => {
    const t               = useTranslate();
    const [open, setOpen] = useState(false)

    const onClickHandler = () => {
        setOpen(!open)
    }
    
    return (
        <div className="landing-container-helper">
            {
                open && (
                    <div className="helper-contact">
                        <div className="helper-contact-header">
                            <div className='helper-contact-header-logo'/>
                            <h1>Merhaba !</h1>
                            <p>Her seyi bizimle paylasabilirsin.</p>
                        </div>
                        <div className="helper-contact-form">
                        <h1>Bize Ulaşın</h1>
                        <UiKit.Row className="mt25">
                            <UiKit.Col sm="12" md="12">
                                <UiKit.Textfield
                                    placeholder = "Isim soyisim giriniz..."
                                    type        = { 'text' }
                                    full        = { true }
                                    attrs       = {{ id : 'login-email' }}
                                    maxLength   = { 128 }
                                    // isDisabled  = { isLoading }
                                    // value       = { s.loginEmail }
                                    // onChange    = { value => changeFormValues('loginEmail', value) }
                                    autoFocus
                                />
                            </UiKit.Col>
                        </UiKit.Row>
                        <UiKit.Row className="mt25">
                            <UiKit.Col sm="12" md="12">
                                <UiKit.Textfield
                                    placeholder = "Mail adresini giriniz..."
                                    type        = { 'email' }
                                    full        = { true }
                                    attrs       = {{ id : 'login-email' }}
                                    maxLength   = { 128 }
                                    // isDisabled  = { isLoading }
                                    // value       = { s.loginEmail }
                                    // onChange    = { value => changeFormValues('loginEmail', value) }
                                />
                            </UiKit.Col>
                        </UiKit.Row>
                        <UiKit.Row className="mt25">
                            <UiKit.Col sm="12" md="12">
                                <UiKit.Textarea
                                    placeholder = "Iletmek istediginizi giriniz..."
                                    full        = { true }
                                    maxLength   = { 128 }
                                    // isDisabled  = { isLoading }
                                    // value       = { s.loginEmail }
                                    // onChange    = { value => changeFormValues('loginEmail', value) }
                                />
                            </UiKit.Col>
                        </UiKit.Row>
                        <UiKit.Row>
                            <UiKit.Col className="mt20" sm="12" md="12">
                                <UiKit.Button
                                    isCustomLabelType
                                    label       = "Gönder"
                                    full        = { true }
                                    // isLoading   = { isLoading }
                                    // isDisabled  = { isLoading }
                                    // onClick     = { () => startLogin() }
                                />
                            </UiKit.Col>
                        </UiKit.Row>
                        </div>
                        <h1>Iletisime Gec</h1>
                        {/* <form>
                            <input placeholder="Ad doyad"></input>
                            <label></label>
                            <input placeholder="Email"></input>
                            <input placeholder="Sirket Adi"></input>
                        </form> */}
                    </div>
                )
            }
            <div className="show-helper">
                <span onClick={() => onClickHandler()}>Bizimle iletişime geç 👋</span>
                <div className="helper-circle" onClick={() => onClickHandler()}>
                    {open && <i className="fas fa-angle-down"></i> || <i className="far fa-comment-dots"></i> }
                </div>
            </div>
        </div>
    )
}

export default Helper
